import { createContext, useContext } from "react";

type PageScrollContextValue = {
  scrollRoot: HTMLElement | null;
  setScrollRoot: (node: HTMLElement | null) => void;
};

export const PageScrollContext = createContext<PageScrollContextValue | null>(null);

export function usePageScrollRoot(): HTMLElement | null {
  return useContext(PageScrollContext)?.scrollRoot ?? null;
}
